export enum AdminCustomerDPApiErrorTypes {
  AdminLoadCustomerDPsError,
  AdminLoadCustomerDPsCsvError,
  AdminDeleteCustomerDPError,
}

export class AdminCustomerDPApiError {
  constructor(public type: AdminCustomerDPApiErrorTypes, public error: Error) {}
}
